<template>
    <Layout data-step="order" class="order order-flight">
        <HomeConfirm />
    </Layout>
</template>
<script>
import Layout from "@/views/home/layout.vue";
import HomeConfirm from "@/views/home/components/HomeConfirm.vue";

export default {
    components: { HomeConfirm, Layout }
}
</script>
